import { enableProdMode,  LOCALE_ID, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AuthService } from './app/security/auth.service';
import { AuthGuard } from './app/security/auth-guard.service';
import { MatNativeDateModule, MatRippleModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import {  MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import {  MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { DatePipe, CommonModule, CurrencyPipe } from '@angular/common';
import { DashboardService } from './app/dashboard/service/dashboard.service';
import { WebSocketAPI } from './app/utilerias/WebSocketAPI';
import { AltaperfilService } from './app/security/altaperfil.service';
import { PerfilService } from './app/security/perfil/perfil.service';
import { ConfiguracionService } from './app/configuraciones/configuracion.service';
import { IncidenciasService } from './app/incidencias/incidencias.service';
import { TicketsService } from './app/tickets/tickets.service';
import { Global } from './app/utilerias/global';
import { SolicitudVacacionesService } from './app/tarea-diaria/solicitud-vacaciones/solicitud-vacaciones.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './app/security/helper/jwt.interceptor';
import { ErrorInterceptor } from './app/security/helper/error.interceptor';
import { NgChartsConfiguration, NgChartsModule } from 'ng2-charts';
import { SpinnerInterceptor } from './app/security/helper/spinner.interceptor';
import { SweetAlertComponent } from './app/shared/SweetMesssage';
import { ComunicacionService } from './app/shared/services/comunicacion.service';
import { RelojService } from './app/shared/services/reloj.service';
import { GenericoService } from './app/shared/services/generico.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { withHashLocation, provideRouter } from '@angular/router';
import { AppRoutes } from './app/app.routing';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';
import { DenunciasModule } from './app/denuncias/denuncias.module';
import { FechaEstandarAdapter, FECHA_ESTANDAR_FORMATS } from './app/utilerias/fecha-estandar.adapter';

import { registerLocaleData } from '@angular/common';
import localeMX from '@angular/common/locales/es-MX';
registerLocaleData(localeMX);


if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
      CurrencyPipe,
      DatePipe,
        importProvidersFrom(CommonModule,
          DenunciasModule,
          FormsModule, ReactiveFormsModule,  
          MatNativeDateModule,  NgxPaginationModule, 
          MatTreeModule,
          NgxMatSelectSearchModule, MatTooltipModule, 
          MatCardModule, BrowserModule, MatProgressSpinnerModule, 
          MatTableModule, VgCoreModule, VgControlsModule, 
          VgOverlayPlayModule, VgBufferingModule, NgChartsModule, 
          ToastrModule.forRoot()), // ToastrModule added
        AuthService,
        AuthGuard,
        MatNativeDateModule,
        { provide: MAT_DATE_LOCALE, useValue: 'en-ES' },
        { provide: DateAdapter, useClass: FechaEstandarAdapter },
        { provide: MAT_DATE_FORMATS, useValue: FECHA_ESTANDAR_FORMATS },
        DashboardService,
 
        WebSocketAPI,
        AltaperfilService,
        PerfilService,
        ConfiguracionService,
        IncidenciasService,
        TicketsService,
        Global,
        SolicitudVacacionesService,
        { provide: LOCALE_ID, useValue: 'es-MX' },
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto' } },
        { provide: NgChartsConfiguration, useValue: { generateColors: false } },
        { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
        SweetAlertComponent,
        ComunicacionService,
        RelojService,
        GenericoService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideRouter(AppRoutes, withHashLocation())
    ]
})
  .catch(err => console.error(err));
